import { render, staticRenderFns } from "./cashier_config.vue?vue&type=template&id=8d35b90c&scoped=true&"
import script from "./cashier_config.vue?vue&type=script&lang=tsx&"
export * from "./cashier_config.vue?vue&type=script&lang=tsx&"
import style0 from "./cashier_config.vue?vue&type=style&index=0&id=8d35b90c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d35b90c",
  null
  
)

export default component.exports